import { render } from "./listCourse.vue?vue&type=template&id=776789b2"
import script from "./listCourse.vue?vue&type=script&lang=js"
export * from "./listCourse.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__